export enum EInputMediaStyleType {
  normal = "normal",
  roundedTop = "roundedTop",
  rounded = "rounded",
}
